
<template>
  <div class="progress" :style="{'height': height}" :class="{'white-border' : isWhite}">
    <div
      class="progress-bar"
      :class="{ 'success': success, 'error': error, 'white-bar': isWhite}"
      role="progressbar"
      :style="{width: fillWidth, height: height}"
      :aria-valuenow="fillWidth"
      aria-valuemin="0"
      aria-valuemax="100"
    >
    <span v-if="showPercentage" class="progress-text">{{ fillWidth }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showPercentage: {
      type: Boolean,
      default: false
    },
    barHeight: {
      type: Number,
      default: 10
    },
    percentage: {
      type: Number,
      required: true
    },
    isWhite: {
      type: Boolean,
      default: false
    },
    error: Boolean,
    success: Boolean
  },
  computed: {
    fillWidth () {
      console.log(this.percentage)
      return this.percentage > 100 ? '100%' : Math.ceil(this.percentage) + '%'
    },
    height () {
      return this.barHeight + 'px'
    }
  }
}
</script>
<style lang="scss" scoped>

.white-border{
  border-color: white !important
}

.white-bar{
  background-color: white !important;
}

.progress {
  border-radius: 4px;
  background-color: transparent;
  border: 1px solid #3B3B3B;
  width: 100%;
  display: block;
  margin-top: auto;

  .progress-bar {
    background-color: #3B3B3B;
  }
  .success {
    background-color: $primary-gold;
  }
  .error {
    background-color: #c6243e;
  }
}

</style>
